import React, { useContext, useState, useEffect, useRef } from 'react';
import { ShopContext } from '../../Context/ShopContext';
import { useNavigate, useLocation } from 'react-router-dom';
import logo from '../Assets/logo.png';
import { 
  FaWhatsapp, 
  FaCopy, 
  FaCheck, 
  FaPrint, 
  FaFilePdf, 
  FaShare,
  FaArrowLeft,
  FaInfoCircle
} from 'react-icons/fa';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import './MpesaModal.css';

const MpesaModal = ({ 
  paybillNumber = '522533', 
  accountNumber = '9900136',
  supportPhone = '254728986068',
  companyName = 'ETOLEE LIVESTOCK LINK',
  companyAddress = 'Lodwar, Kenya',
  companyEmail = 'info@etoleelivestocklink.co.ke',
  onClose
}) => {
  const location = useLocation();
  const { clearCart } = useContext(ShopContext);
  const navigate = useNavigate();
  
  // Initialize state from location or defaults
  const [cartProducts] = useState(location.state?.cartProducts || []);
  const [totalAmount] = useState(location.state?.totalAmount || '0.00');
  const [customerName, setCustomerName] = useState(location.state?.customerName || '');
  const [customerPhone, setCustomerPhone] = useState(location.state?.customerPhone || '');
  
  const [copiedPaybill, setCopiedPaybill] = useState(false);
  const [copiedAccount, setCopiedAccount] = useState(false);
  const [showNameModal, setShowNameModal] = useState(true);
  const [showInvoice, setShowInvoice] = useState(false);
  const [paymentConfirmed, setPaymentConfirmed] = useState(false);
  const [invoiceNumber, setInvoiceNumber] = useState('');
  const [paymentMethod, setPaymentMethod] = useState('M-Pesa');
  const [isProcessing, setIsProcessing] = useState(false);
  const [showPaymentInstructions, setShowPaymentInstructions] = useState(false);
  const invoiceRef = useRef(null);


  // Generate invoice number on mount
  useEffect(() => {
    setInvoiceNumber(generateInvoiceNumber());
  }, []);

  const generateInvoiceNumber = () => {
    const date = new Date();
    const randomNum = Math.floor(1000 + Math.random() * 9000);
    return `INV-${date.getFullYear()}${(date.getMonth()+1).toString().padStart(2, '0')}${date.getDate().toString().padStart(2, '0')}-${randomNum}`;
  };

  const handleBackToCart = () => {
    if (onClose) {
      onClose();
    } else {
      navigate(-1);
    }
  };

  const generateWhatsappMessage = () => {
    if (cartProducts.length === 0) return '';
    
    const productList = cartProducts.map(product => {
      let itemDetails = `▫️ ${product.name} (${product.quantity} x Ksh.${product.newPrice.toFixed(2)})`;
      if (product.selectedSize) itemDetails += `%0A   Size: ${product.selectedSize}`;
      if (product.selectedColor) itemDetails += `%0A   Color: ${product.selectedColor}`;
      return itemDetails;
    }).join('%0A%0A');

    return `Hello! I'd like to confirm my order:%0A%0A${productList}%0A%0A💰 *Total: Ksh.${totalAmount}*%0A%0A💳 *Payment Details*%0A- Paybill: ${paybillNumber}%0A- Account: ${accountNumber}%0A- Invoice: ${invoiceNumber}%0A%0AI've made the payment via ${paymentMethod}. Please confirm receipt.`;
  };

  const copyToClipboard = (text, setCopied) => {
    navigator.clipboard.writeText(text)
      .then(() => {
        setCopied(true);
        toast.success('Copied to clipboard!', { 
          position: 'top-center',
          autoClose: 1500
        });
        setTimeout(() => setCopied(false), 2000);
      })
      .catch(err => {
        toast.error('Failed to copy text', { position: 'top-center' });
        console.error('Failed to copy text: ', err);
      });
  };

  const validatePhoneNumber = (phone) => {
    const regex = /^254\d{9}$/;
    return regex.test(phone);
  };

  const handlePaymentConfirmation = (e) => {
    e.preventDefault();
    
    if (cartProducts.length === 0) {
      toast.error('Your cart is empty', { position: 'top-center' });
      return;
    }

    if (!customerName.trim()) {
      toast.error('Please enter your full name', { position: 'top-center' });
      return;
    }

    if (!customerPhone.trim()) {
      toast.error('Please enter your phone number', { position: 'top-center' });
      return;
    }

    if (!validatePhoneNumber(customerPhone)) {
      toast.error('Please enter a valid Kenyan phone number starting with 254', { 
        position: 'top-center',
        autoClose: 3000
      });
      return;
    }

    setIsProcessing(true);

    setTimeout(() => {
      setPaymentConfirmed(true);
      setShowInvoice(true);
      setShowNameModal(false);
      clearCart();
      toast.success('Processing Payment  successfully!', { position: 'top-center' });
      setIsProcessing(false);
      
      // Save transaction history
      const transaction = {
        invoiceNumber,
        customerName,
        customerPhone,
        totalAmount,
        date: new Date().toISOString(),
        products: cartProducts,
        paymentMethod
      };
      
      const transactions = JSON.parse(localStorage.getItem('transactions') || '[]');
      transactions.push(transaction);
      localStorage.setItem('transactions', JSON.stringify(transactions));

      // Save customer details for future use
      localStorage.setItem('user-name', customerName);
      localStorage.setItem('user-phone', customerPhone);
    }, 1500);
  };

  const printInvoice = () => {
    if (cartProducts.length === 0) {
      toast.error('No products to display in invoice', { position: 'top-center' });
      return;
    }

    const printWindow = window.open('', '_blank');
    const printContent = `
      <!DOCTYPE html>
      <html>
        <head>
          <title>Invoice ${invoiceNumber}</title>
          <style>
            body { font-family: Arial, sans-serif; margin: 0; padding: 20px; color: #333; }
            .invoice-container { max-width: 800px; margin: 0 auto; padding: 20px; }
            .invoice-header { display: flex; justify-content: space-between; margin-bottom: 20px; }
            .invoice-brand { display: flex; align-items: center; }
            .invoice-logo { height: 60px; margin-right: 15px; }
            .invoice-meta { text-align: right; }
            .invoice-number { font-weight: bold; margin: 5px 0; }
            .status-badge { 
              padding: 5px 10px; 
              border-radius: 4px; 
              font-weight: bold;
              display: inline-block;
              margin-top: 5px;
            }
            .confirmed { background-color: #d4edda; color: #155724; }
            .pending { background-color: #fff3cd; color: #856404; }
            .invoice-body { margin-top: 30px; }
            .invoice-details { display: flex; justify-content: space-between; margin-bottom: 30px; }
            .detail-col { flex: 1; }
            .items-table { width: 100%; border-collapse: collapse; margin: 20px 0; }
            .table-header { font-weight: bold; border-bottom: 2px solid #ddd; padding: 10px 0; }
            .table-row { border-bottom: 1px solid #eee; padding: 10px 0; }
            .table-col { padding: 8px 5px; }
            .desc-col { width: 40%; }
            .qty-col, .price-col { width: 15%; text-align: center; }
            .amount-col { width: 30%; text-align: right; }
            .item-name { font-weight: bold; }
            .item-variant { font-size: 0.9em; color: #666; }
            .invoice-totals { margin-top: 20px; text-align: right; }
            .total-row { margin: 5px 0; }
            .grand-total { font-weight: bold; font-size: 1.1em; margin-top: 10px; }
            .payment-status { display: flex; justify-content: space-between; margin-top: 30px; }
            .status-col { flex: 1; }
            .status { font-weight: bold; }
            .invoice-footer { margin-top: 40px; font-size: 0.9em; }
            .thank-you { margin-bottom: 20px; }
            .contact-info { margin: 20px 0; }
            .terms { margin-top: 30px; }
            .invoice-watermark {
             font-weight: bolder;
             font-style: 90px;
              position: fixed;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%) rotate(-45deg);
              font-size: 80px;
              color: rgba(0,0,0,0.1);
              z-index: 1000;
              pointer-events: none;
            }
            @page { size: auto; margin: 10mm; }
            @media print {
              body { padding: 0; }
              .no-print { display: none !important; }
            }
          </style>
        </head>
        <body>
          <div class="invoice-container">
            <div class="invoice-header">
              <div class="invoice-brand">
                <img src="${logo}" alt="Company Logo" class="invoice-logo" />
                <div>
                  <h2>${companyName}</h2>
                  <p>${companyAddress}</p>
                  <p>Tel: ${supportPhone} | Email: ${companyEmail}</p>
                </div>
              </div>
              
              <div class="invoice-meta">
                <h1>INVOICE</h1>
                <div class="invoice-number">#${invoiceNumber}</div>
                <div class="status-badge ${paymentConfirmed ? 'confirmed' : 'pending'}">
                  ${paymentConfirmed ? 'PROCESSING' : 'PENDING'}
                </div>
              </div>
            </div>
            
            <div class="invoice-body">
              <div class="invoice-details">
                <div class="detail-col">
                  <h4>Bill To:</h4>
                  <p>${customerName}</p>
                  <p>Phone: ${customerPhone}</p>
                </div>
                
                <div class="detail-col">
                  <h4>Invoice Date:</h4>
                  <p>${new Date().toLocaleDateString('en-US', {
                    year: 'numeric', 
                    month: 'short', 
                    day: 'numeric', 
                    hour: '2-digit', 
                    minute: '2-digit'
                  })}</p>
                  <h4>Payment Method:</h4>
                  <p>${paymentMethod}</p>
                </div>
                
                ${paymentMethod === 'M-Pesa' ? `
                <div class="detail-col">
                  <h4>M-Pesa Details:</h4>
                  <p>Paybill: ${paybillNumber}</p>
                  <p>Account: ${accountNumber}</p>
                </div>
                ` : ''}
              </div>
              
              <div class="items-table">
                <div class="table-header" style="display: flex;">
                  <div class="table-col desc-col">Description</div>
                  <div class="table-col qty-col">Qty</div>
                  <div class="table-col price-col">Unit Price</div>
                  <div class="table-col amount-col">Amount</div>
                </div>
                
                ${cartProducts.map(product => `
                  <div class="table-row" style="display: flex;">
                    <div class="table-col desc-col">
                      <div class="item-name">${product.name}</div>
                      ${product.selectedSize ? `<div class="item-variant">Size: ${product.selectedSize}</div>` : ''}
                      ${product.selectedColor ? `<div class="item-variant">Color: ${product.selectedColor}</div>` : ''}
                    </div>
                    <div class="table-col qty-col">${product.quantity}</div>
                    <div class="table-col price-col">Ksh.${product.newPrice.toFixed(2)}</div>
                    <div class="table-col amount-col">Ksh.${(product.newPrice * product.quantity).toFixed(2)}</div>
                  </div>
                `).join('')}
              </div>
              
              <div class="invoice-totals">
                <div class="total-row">
                  <span>Subtotal:</span>
                  <span>Ksh.${cartProducts.reduce((sum, product) => sum + (product.newPrice * product.quantity), 0).toFixed(2)}</span>
                </div>
                <div class="total-row">
                  <span>Tax (0%):</span>
                  <span>Ksh.0.00</span>
                </div>
                <div class="total-row grand-total">
                  <span>Total Amount:</span>
                  <span>Ksh.${totalAmount}</span>
                </div>
              </div>
              
              <div class="payment-status">
                <div class="status-col">
                  <h4>Payment Status:</h4>
                  <div class="status ${paymentConfirmed ? 'Processing' : 'pending'}">
                    ${paymentConfirmed ? 'Processing Payment' : 'Pending Payment'}
                  </div>
                </div>
                <div class="status-col">
                  <h4>Payment Date:</h4>
                  <div>${new Date().toLocaleDateString('en-US', {
                    year: 'numeric', 
                    month: 'short', 
                    day: 'numeric', 
                    hour: '2-digit', 
                    minute: '2-digit'
                  })}</div>
                </div>
              </div>
              
              <div class="invoice-footer">
                <div class="thank-you">
                  <p>Thank you for your business!</p>
                  <p>We appreciate your trust in our services.</p>
                </div>
                
                <div class="contact-info">
                  <p>For any inquiries, please contact us:</p>
                  <p>Phone: ${supportPhone} | Email: ${companyEmail}</p>
                </div>
                
                <div class="terms">
                  <h4>Terms & Conditions:</h4>
                  <ol>
                    <li>Payment must be made within 24 hours of invoice issuance.</li>
                    <li>Prices are subject to change without prior notice.</li>
                  </ol>
                </div>
              </div>
            </div>
            
            ${paymentConfirmed ? `
            <div class="invoice-watermark">
              ETOLEE INVOICE
            </div>
            ` : ''}
          </div>
          <script>
            window.onload = function() {
              window.print();
              setTimeout(() => window.close(), 500);
            };
          </script>
        </body>
      </html>
    `;

    printWindow.document.write(printContent);
    printWindow.document.close();
  };

  const downloadInvoiceAsPDF = async () => {
    if (cartProducts.length === 0) {
      toast.error('No products to generate invoice', { position: 'top-center' });
      return;
    }

    toast.info('Generating PDF...', { position: 'top-center' });
    
    try {
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = `
        <div style="font-family: Arial, sans-serif; max-width: 800px; margin: 0 auto; padding: 20px;">
          ${invoiceRef.current.innerHTML}
        </div>
      `;
      document.body.appendChild(tempDiv);

      const canvas = await html2canvas(tempDiv, {
        scale: 2,
        useCORS: true,
        logging: false,
        backgroundColor: '#fff',
        scrollX: 0,
        scrollY: 0
      });
      
      document.body.removeChild(tempDiv);

      const pdf = new jsPDF('p', 'mm', 'a4');
      const imgData = canvas.toDataURL('image/png');
      const imgWidth = 190;
      const pageHeight = 277;
      const imgHeight = canvas.height * imgWidth / canvas.width;
      let heightLeft = imgHeight;
      let position = 10;

      pdf.addImage(imgData, 'PNG', 10, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;

      while (heightLeft >= 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(imgData, 'PNG', 10, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
      }
      
      pdf.save(`invoice_${invoiceNumber}.pdf`);
      
      toast.success('PDF downloaded successfully!', { position: 'top-center' });
    } catch (error) {
      console.error('Error generating PDF:', error);
      toast.error('Failed to generate PDF', { position: 'top-center' });
    }
  };

  const shareInvoice = async () => {
    try {
      if (!navigator.share) {
        toast.info('Web Share API not supported in your browser', { position: 'top-center' });
        return;
      }

      const input = invoiceRef.current;
      const canvas = await html2canvas(input, { 
        scale: 2,
        useCORS: true,
        logging: false,
        backgroundColor: '#fff'
      });
      const image = canvas.toDataURL('image/png');
      
      const blob = await (await fetch(image)).blob();
      const file = new File([blob], `invoice_${invoiceNumber}.png`, { type: blob.type });
      
      await navigator.share({
        title: `Invoice ${invoiceNumber}`,
        text: `Your invoice from ${companyName} for Ksh.${totalAmount}`,
        files: [file]
      });
    } catch (error) {
      if (error.name !== 'AbortError') {
        console.error('Error sharing invoice:', error);
        toast.error('Failed to share invoice. You can try downloading instead.', { 
          position: 'top-center',
          autoClose: 3000
        });
      }
    }
  };

  const renderMpesaInstructions = () => {
    return (
      <div className="etole-mpesa-instructions">
        <h4><FaInfoCircle /> M-Pesa Payment Instructions:</h4>
        <ol>
          <li>Go to <strong>M-Pesa</strong> on your phone</li>
          <li>Select <strong>Lipa na M-Pesa</strong></li>
          <li>Select <strong>Pay Bill</strong></li>
          <li>Enter Business Number: <strong>{paybillNumber}</strong></li>
          <li>Enter Account Number: <strong>{accountNumber}</strong></li>
          <li>Enter Amount: <strong>Ksh.{totalAmount}</strong></li>
          <li>Enter your <strong>M-Pesa PIN</strong> and confirm</li>
        </ol>
        <p>You will receive a confirmation SMS from M-Pesa.</p>
      </div>
    );
  };

  return (
    <div className="etole-payment-modal">
      {/* Customer Information Form */}
      {showNameModal && (
        <div className="etole-modal-overlay">
          <div className="etole-modal-content">
            <button 
              className="etole-close-btn" 
              onClick={handleBackToCart}
              aria-label="Back to cart"
            >
              <FaArrowLeft />
            </button>
            
            <div className="etole-modal-header">
              <img src={logo} alt="Logo" className="etole-modal-logo" />
              <h3>Complete Your Order</h3>
              <p>Please provide your details to proceed with payment</p>
            </div>
            
            <form onSubmit={handlePaymentConfirmation}>
              <div className="etole-form-group">
                <label htmlFor="customerName">Full Name *</label>
                <input
                  id="customerName"
                  type="text"
                  value={customerName}
                  onChange={(e) => setCustomerName(e.target.value)}
                  placeholder="John Doe"
                  required
                />
              </div>
              
              <div className="etole-form-group">
                <label htmlFor="customerPhone">Phone Number (254...) *</label>
                <input
                  id="customerPhone"
                  type="tel"
                  value={customerPhone}
                  onChange={(e) => setCustomerPhone(e.target.value)}
                  placeholder="2547XXXXXXXX"
                  pattern="254\d{9}"
                  required
                />
                <small className="etole-phone-hint">Format: 254 followed by 9 digits (e.g., 254712345678)</small>
              </div>
              
              <div className="etole-form-group">
                <label>Payment Method *</label>
                <select 
                  value={paymentMethod}
                  onChange={(e) => setPaymentMethod(e.target.value)}
                  required
                >
                  <option value="M-Pesa">M-Pesa</option>
                  <option value="Cash">Cash on Delivery</option>
                  <option value="Bank Transfer">Bank Transfer</option>
                </select>
              </div>
              
              {paymentMethod === 'M-Pesa' && (
                <div className="etole-payment-details">
                  <div className="etole-detail-item">
                    <span>Paybill Number:</span>
                    <div className="etole-copy-field">
                      <span>{paybillNumber}</span>
                      <button 
                        type="button" 
                        onClick={() => copyToClipboard(paybillNumber, setCopiedPaybill)}
                        className="etole-copy-btn"
                      >
                        {copiedPaybill ? <FaCheck /> : <FaCopy />}
                      </button>
                    </div>
                  </div>
                  
                  <div className="etole-detail-item">
                    <span>Account Number:</span>
                    <div className="etole-copy-field">
                      <span>{accountNumber}</span>
                      <button 
                        type="button" 
                        onClick={() => copyToClipboard(accountNumber, setCopiedAccount)}
                        className="etole-copy-btn"
                      >
                        {copiedAccount ? <FaCheck /> : <FaCopy />}
                      </button>
                    </div>
                  </div>
                  
                  <button 
                    type="button" 
                    className="etole-instructions-btn"
                    onClick={() => setShowPaymentInstructions(!showPaymentInstructions)}
                  >
                    {showPaymentInstructions ? 'Hide Instructions' : 'Show M-Pesa Instructions'}
                  </button>
                  
                  {showPaymentInstructions && renderMpesaInstructions()}
                </div>
              )}
              
              <div className="etole-order-summary">
                <h4>Order Summary</h4>
                <div className="etole-summary-items">
                  {cartProducts.length > 0 ? (
                    cartProducts.map((product, index) => (
                      <div key={index} className="etole-summary-item">
                        <span>{product.name} × {product.quantity}</span>
                        <span>Ksh.{(product.newPrice * product.quantity).toFixed(2)}</span>
                      </div>
                    ))
                  ) : (
                    <div className="etole-empty-cart">
                      Your cart is empty. Please add items to proceed.
                    </div>
                  )}
                </div>
                
                <div className="etole-summary-total">
                  <span>Total Amount:</span>
                  <span>Ksh.{totalAmount}</span>
                </div>
              </div>
              
              <button 
                type="submit" 
                className="etole-submit-btn"
                disabled={isProcessing || cartProducts.length === 0}
              >
                {isProcessing ? (
                  <span className="etole-spinner"></span>
                ) : (
                  `Confirm ${paymentMethod === 'Cash' ? 'Order' : 'Payment'}`
                )}
              </button>
            </form>
          </div>
        </div>
      )}

      {/* Invoice Display */}
      {showInvoice && (
        <div className="etole-modal-overlay">
          <div className="etole-invoice-container">
            <div className="etole-invoice-content" ref={invoiceRef}>
              {/* Invoice Header */}
              <div className="etole-invoice-header">
                <div className="etole-invoice-brand">
                  <img src={logo} alt="Company Logo" className="etole-invoice-logo" />
                  <div>
                    <h2>{companyName}</h2>
                    <p>{companyAddress}</p>
                    <p>Tel: {supportPhone} | Email: {companyEmail}</p>
                  </div>
                </div>
                
                <div className="etole-invoice-meta">
                  <h1>INVOICE</h1>
                  <div className="etole-invoice-number">#{invoiceNumber}</div>
                  <div className={`etole-status-badge ${paymentConfirmed ? 'confirmed' : 'pending'}`}>
                    {paymentConfirmed ? 'PROCESSING' : 'PENDING'}
                  </div>
                </div>
              </div>
              
              {/* Invoice Body */}
              <div className="etole-invoice-body">
                <div className="etole-invoice-details">
                  <div className="etole-detail-col">
                    <h4>Bill To:</h4>
                    <p>{customerName}</p>
                    <p>Phone: {customerPhone}</p>
                  </div>
                  
                  <div className="etole-detail-col">
                    <h4>Invoice Date:</h4>
                    <p>{new Date().toLocaleDateString('en-US', {
                      year: 'numeric', 
                      month: 'short', 
                      day: 'numeric', 
                      hour: '2-digit', 
                      minute: '2-digit'
                    })}</p>
                    <h4>Payment Method:</h4>
                    <p>{paymentMethod}</p>
                  </div>
                  
                  {paymentMethod === 'M-Pesa' && (
                    <div className="etole-detail-col">
                      <h4>M-Pesa Details:</h4>
                      <p>Paybill: {paybillNumber}</p>
                      <p>Account: {accountNumber}</p>
                    </div>
                  )}
                </div>
                
                {/* Items Table */}
                <div className="etole-items-table">
                  <div className="etole-table-header">
                    <div className="etole-table-col etole-desc-col">Description</div>
                    <div className="etole-table-col etole-qty-col">Qty</div>
                    <div className="etole-table-col etole-price-col">Unit Price</div>
                    <div className="etole-table-col etole-amount-col">Amount</div>
                  </div>
                  
                  {cartProducts.map((product, index) => (
                    <div key={index} className="etole-table-row">
                      <div className="etole-table-col etole-desc-col">
                        <div className="etole-item-name">{product.name}</div>
                        {product.selectedSize && <div className="etole-item-variant">Size: {product.selectedSize}</div>}
                        {product.selectedColor && <div className="etole-item-variant">Color: {product.selectedColor}</div>}
                      </div>
                      <div className="etole-table-col etole-qty-col">{product.quantity}</div>
                      <div className="etole-table-col etole-price-col">Ksh.{product.newPrice.toFixed(2)}</div>
                      <div className="etole-table-col etole-amount-col">Ksh.{(product.newPrice * product.quantity).toFixed(2)}</div>
                    </div>
                  ))}
                </div>
                
                {/* Totals Section */}
                <div className="etole-invoice-totals">
                  <div className="etole-total-row">
                    <span>Subtotal:</span>
                    <span>Ksh.{cartProducts.reduce((sum, product) => sum + (product.newPrice * product.quantity), 0).toFixed(2)}</span>
                  </div>
                  <div className="etole-total-row">
                    <span>Tax (0%):</span>
                    <span>Ksh.0.00</span>
                  </div>
                  <div className="etole-total-row etole-grand-total">
                    <span>Total Amount:</span>
                    <span>Ksh.{totalAmount}</span>
                  </div>
                </div>
                
                {/* Payment Status */}
                <div className="etole-payment-status">
                  <div className="etole-status-col">
                    <h4>Payment Status:</h4>
                    <div className={`etole-status ${paymentConfirmed ? 'Processing Transaction' : 'pending'}`}>
                      {paymentConfirmed ? 'PROCESSING' : 'Pending Payment'}
                    </div>
                  </div>
                  <div className="etole-status-col">
                    <h4>Payment Date:</h4>
                    <div>{new Date().toLocaleDateString('en-US', {
                      year: 'numeric', 
                      month: 'short', 
                      day: 'numeric', 
                      hour: '2-digit', 
                      minute: '2-digit'
                    })}</div>
                  </div>
                </div>
                
                {/* Footer */}
                <div className="etole-invoice-footer">
                  <div className="etole-thank-you">
                    <p>Thank you for your business!</p>
                    <p>We appreciate your trust in our services.</p>
                  </div>
                  
                  <div className="etole-contact-info">
                    <p>For any inquiries, please contact us:</p>
                    <p>Phone: {supportPhone} | Email: {companyEmail}</p>
                  </div>
                  
                  <div className="etole-terms">
                    <h4>Terms & Conditions:</h4>
                    <ol>
                      <li>Payment must be made within 24 hours of invoice issuance.</li>
                      <li>Prices are subject to change without prior notice.</li>
                    </ol>
                  </div>
                </div>
              </div>
              
              {/* Watermark */}
              {paymentConfirmed && (
                <div className="etole-invoice-watermark">
                  ETOLEE INVOICE
                </div>
              )}
            </div>
            
            {/* Invoice Actions */}
            <div className="etole-invoice-actions">
              <button 
                onClick={printInvoice} 
                className="etole-action-btn"
                disabled={cartProducts.length === 0}
              >
                <FaPrint /> Print Invoice
              </button>
              <button 
                onClick={downloadInvoiceAsPDF} 
                className="etole-action-btn"
                disabled={cartProducts.length === 0}
              >
                <FaFilePdf /> Save as PDF
              </button>
              {navigator.share && (
                <button 
                  onClick={shareInvoice} 
                  className="etole-action-btn"
                  disabled={cartProducts.length === 0}
                >
                  <FaShare /> Share
                </button>
              )}
              <a 
                href={`https://wa.me/${supportPhone}?text=${generateWhatsappMessage()}`}
                className="etole-action-btn"
                target="_blank"
                rel="noopener noreferrer"
                disabled={cartProducts.length === 0}
              >
                <FaWhatsapp /> WhatsApp
              </a>
              <button 
                onClick={() => navigate('/')} 
                className="etole-action-btn etole-close"
              >
                Back to Home
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MpesaModal;